/* oxlint-disable */
'use client';

import { useEffect, useCallback, useState } from 'react';

import Image from 'next/image';

import { isMobile } from 'react-device-detect';
import { IoChevronBack } from 'react-icons/io5';

import { userUIStore } from '@/stores/userUIStore';
import { ButtonIcon } from '@/stories/atoms/buttons/buttonIcon/ButtonIcon';

import { MisionesSheetProps } from './interface';

import { ScrollArea } from '../ui/scroll-area';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '../ui/sheet';

const MisionesSheet = ({
  missionBoardName = 'Dark Mission Board',
  open: controlledOpen,
  onOpenChange,
  fromProfile = false,
}: MisionesSheetProps) => {
  const { isSidebarOpen } = userUIStore();
  const [internalOpen, setInternalOpen] = useState(false);

  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : internalOpen;

  const handleOpenChange = useCallback((newOpen: boolean) => {
    if (isControlled && onOpenChange) {
      onOpenChange(newOpen);
    } else {
      setInternalOpen(newOpen);
    }
  }, [isControlled, onOpenChange]);

  const handleClose = useCallback(() => {
    handleOpenChange(false);
  }, [handleOpenChange]);

  // Initialize Solitics mission board when component mounts
  // Temporarily disabled while working on missions feature
  // useEffect(() => {
  //   // Small delay to ensure DOM is ready
  //   const timer = setTimeout(() => {
  //     if (typeof window !== 'undefined' && (window as any).$solitics) {
  //       try {
  //         // Initialize the mission board widget
  //         (window as any).$solitics.initMissionBoard('missionBoardSheet', {
  //           name: missionBoardName,
  //           container: '#missionBoardSheet',
  //         });
  //       } catch (error) {
  //         console.warn('Solitics mission board initialization failed:', error);
  //       }
  //     }
  //   }, 500);

  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, [missionBoardName]);

  return (
    <Sheet
      modal={false}
      open={open}
      onOpenChange={handleOpenChange}
    >
      {!fromProfile && (
        <SheetTrigger className="mr-2">
          <div className="w-full ">
            <div
              className={`${isSidebarOpen ? 'flex-row-reverse justify-between ms-4' : ' mx-auto flex-col justify-center ms-1'} hidden md:flex h-20 w-full rounded-lg py-2  items-center `}
              style={{
                background: 'linear-gradient(to right, #0037460e, #34C6E98e)',
              }}
            >
              <Image
                src="/img/v2/home/dart.webp"
                alt="dart"
                width={isSidebarOpen ? 80 : 50}
                height={isSidebarOpen ? 80 : 50}
                className="mx-auto"
              />
              <p className={`${isSidebarOpen ? 'text-lg font-bold' : 'text-[10px]'} text-white text-center font-title`}>Misiones</p>
            </div>
            <div className="bg-white/15 w-10 h-10 flex items-center justify-center mt-1 rounded-full md:hidden">
              <Image
                src="/img/v2/home/dart.webp"
                alt="dart"
                width={30}
                height={30}
                className="mx-auto"
              />
            </div>
          </div>
        </SheetTrigger>
      )}
      <SheetContent
        side={isMobile ? 'bottom' : 'right'}
        className="bg-sivarbet-background border-sivarbet-border text-sivarbet-text h-full w-full rounded-t shadow-2xl shadow-gray backdrop-opacity-30 px-0 pt-0 pb-20 [&>button]:hidden"
      >
        <SheetHeader className="place-items-start py-2">
          <SheetTitle className="flex items-center justify-center px-3 w-full gap-2">
            <div className="absolute left-2 top-2 flex-1 justify-center z-50">
              <ButtonIcon
                mode="outline"
                size="medium"
                disabled={false}
                icon={IoChevronBack}
                onPress={handleClose}
              />
            </div>
            <div className="flex items-center gap-2 z-30 flex-1 justify-center">
              <div className="w-8 h-8 flex items-center justify-center">
                <Image
                  src="/img/v2/home/dart.webp"
                  alt="Misiones Icon"
                  width={32}
                  height={32}
                  className="w-8 h-8"
                />
              </div>
              <span className="text-lg text-sivarbet-text">Misiones</span>
            </div>
            <div className="w-[34px]" />
          </SheetTitle>
        </SheetHeader>
        <ScrollArea className="h-full w-full">
          <div className="bg-sivarbet-background text-sivarbet-text border-sivarbet-border pb-0 mr-7 w-full p-4">

            {/* Coming Soon Message */}
            <div className="bg-[#245494]/10 rounded-lg p-8 min-h-[400px] flex flex-col items-center justify-center text-center">
              <div className="mb-4">
                <svg
                  className="w-16 h-16 mx-auto text-sivarbet-primary"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">
                Próximamente
              </h2>
              <p className="text-muted-foreground max-w-md">
                ¡Muy pronto podrás completar desafíos y ganar premios exclusivos!
              </p>
            </div>
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
};

export { MisionesSheet };
